import { parseExpression, stripHtml } from '@/helpers/ExpressionParser';

export default new class  Right {

    parse(data, values) {
        const parsedExpression = parseExpression(data.data.str.value, values, 'unwrap');
        const plainText = stripHtml(parsedExpression.value);
        const right = plainText.slice(0 - parseInt(data.data.str.numOfCharacters));
        parsedExpression.value = parsedExpression.value.replace(plainText, right);
        return parsedExpression;
    }
};
